import { render, staticRenderFns } from "./AddressDetails.vue?vue&type=template&id=edb4a69c&scoped=true"
import script from "./AddressDetails.vue?vue&type=script&lang=ts"
export * from "./AddressDetails.vue?vue&type=script&lang=ts"
import style0 from "./AddressDetails.vue?vue&type=style&index=0&id=edb4a69c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb4a69c",
  null
  
)

export default component.exports